import NoDataFoundSvg from '../../../../assets/inlineSvg/no-data-illustration.svg'
import NoDataFoundSeachSvg from '../../../../assets/inlineSvg/not-found-search-illustration.svg'
import NoResultsFoundSvg from '../../../../assets/inlineSvg/no-results-found.svg'
import WorldMapComputer from '../../../../assets/inlineSvg/world-map-computer-illustration.svg'
import '../cookieConsentOverview.less'
import React from 'react'
import { useIntl } from 'react-intl'

export const EmptyConsentsByDomainWidget = (): React.ReactElement => {
  const intl = useIntl()
  return (
    <div className="cookie-consent-empty-content-wrapper">
      <NoDataFoundSvg />
      {intl.formatMessage({ id: 'cookieConsent.overview.emptyConsentsByDomain' })}
    </div>
  )
}

export const EmptyConsentsByCategoryWidget = (): React.ReactElement => {
  const intl = useIntl()
  return (
    <div className="cookie-consent-empty-content-wrapper">
      <NoDataFoundSeachSvg />
      {intl.formatMessage({ id: 'cookieConsent.overview.emptyConsentsByCategory' })}
    </div>
  )
}

export const EmptyConsentsByCategoryTop5Widget = (): React.ReactElement => {
  const intl = useIntl()
  return (
    <div className="cookie-consent-empty-content-wrapper">
      <NoResultsFoundSvg />
      {intl.formatMessage({ id: 'cookieConsent.overview.emptyConsentsByDomain' })}
    </div>
  )
}

export const EmptyConsentsByRegionWidget = (): React.ReactElement => {
  const intl = useIntl()
  return (
    <div className="cookie-consent-empty-content-wrapper">
      <WorldMapComputer />
      {intl.formatMessage({ id: 'cookieConsent.overview.emptyConsentsByDomain' })}
    </div>
  )
}
